import {PORT_MUTATION_TYPES} from "../../../store/mutation-types";

/**
 * Port mutations
 */

const mutations = {
	/**
	 * Save the incoming shipping requests
	 * @param {*} state
	 * @param {*} shippingRequests
	 */

	 [PORT_MUTATION_TYPES.SAVE_INCOMING_SHIPPING_REQUESTS](state, shippingRequests){
		 state.incomingShipments = shippingRequests
	 },

	 /**
	 * Save the docked shipping requests
	 * @param {*} state
	 * @param {*} shippingRequests
	 */

	[PORT_MUTATION_TYPES.SAVE_DOCKED_SHIPPING_REQUESTS](state, shippingRequests){
		state.dockedShipments = shippingRequests
	},

	 /**
	 * Save the docked shipping requests
	 * @param {*} state
	 * @param {*} shippingRequests
	 */

	[PORT_MUTATION_TYPES.SAVE_DEPARTURE_SHIPPING_REQUESTS](state, shippingRequests){
		state.departureShipments = shippingRequests
	},

	/**
	* Save all shipping requests
	* @param {*} state
	* @param {*} shippingRequests
	*/

   [PORT_MUTATION_TYPES.SAVE_ALL_PORT_SHIPPING_REQUESTS](state, shippingRequests){
	   state.allPortShipments = shippingRequests
   },

	/**
	 * Save the shipping requests dashboard stats
	 * @param {*} state
	 * @param {*} portShippingStats
	 */
	[PORT_MUTATION_TYPES.SAVE_PORT_SHIPPING_REQUEST_STATISTICS](state, portShippingStats){
		state.portStatistics = portShippingStats
	},

	/**
	 * Save the shipping requests disptach by truck
	 * @param {*} state
	 * @param {*} shippingRequests
	 */
	[PORT_MUTATION_TYPES.SAVE_DISPATCH_TRUCK_SHIPPING_REQUESTS](state, shippingRequests){
		state.dispatchByTruckShippingRequests = shippingRequests
	},

	/**
	 * Save the shipping requests disptach by ship
	 * @param {*} state
	 * @param {*} shippingRequests
	 */
	[PORT_MUTATION_TYPES.SAVE_DISPATCH_SHIP_SHIPPING_REQUESTS](state, shippingRequests){
		state.dispatchByShipShippingRequests = shippingRequests
	},

	/**
	 * Save the search query results
	 * @param {*} state
	 * @param {*} shippingRequests
	 */
	[PORT_MUTATION_TYPES.SAVE_PORT_SEARCH_AND_FILTER_REQUESTS](state, shippingRequests){
		state.portSearchQueryResult = shippingRequests
	}  

}

export default mutations